import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601 date string, e.g. `2013-12-01T10:00:00.000Z`. */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** Represents a 64-bit signed integer. */
  Long: any;
  /** Represents a 32-bit unsigned integer. */
  UInt: any;
};

export type Akte = {
  __typename?: "Akte";
  id: Scalars["ID"];
  title: Scalars["String"];
  description: Scalars["String"];
  date: Scalars["Date"];
  lastEdited: Scalars["Date"];
  archived?: Maybe<Scalars["Boolean"]>;
  glaeubiger: Array<Person>;
  schuldner: Array<Person>;
};

export type Aufstellung = {
  __typename?: "Aufstellung";
  entries: Array<AufstellungListenEintrag>;
  summary: AufstellungZusammenfassung;
};

export type AufstellungListenEintrag = {
  __typename?: "AufstellungListenEintrag";
  date: Scalars["Date"];
  description: Scalars["String"];
  umsatz: Scalars["Float"];
  saldo?: Maybe<Scalars["Float"]>;
  generalType: GeneralType;
  subType: SubType;
  definedOn?: Maybe<DefinedOnType>;
};

export type AufstellungZusammenfassung = {
  __typename?: "AufstellungZusammenfassung";
  date: Scalars["Date"];
  hauptforderungen: Scalars["Float"];
  verzinslicheKosten: Scalars["Float"];
  unverzinslicheKosten: Scalars["Float"];
  zinsenHauptforderungen: Scalars["Float"];
  kostenZinsen: Scalars["Float"];
  summeZahlungen: Scalars["Float"];
  gesamt: Scalars["Float"];
  tagesZins: Tageszins;
};

export type Buchung = {
  __typename?: "Buchung";
  amount: Scalars["Float"];
  date: Scalars["Date"];
  description: Scalars["String"];
  verrechnung: Verrechnung;
};

export type BuchungInput = {
  amount: Scalars["Float"];
  date: Scalars["Date"];
  description: Scalars["String"];
  verrechnung: Verrechnung;
};

export type Comment = {
  __typename?: "Comment";
  date: Scalars["Date"];
  description: Scalars["String"];
};

export type CommentInput = {
  date: Scalars["Date"];
  description: Scalars["String"];
};

export type CreateAkteInput = {
  title: Scalars["String"];
  description: Scalars["String"];
  date?: Maybe<Scalars["Date"]>;
};

export type CreateFoko = {
  date: Scalars["Date"];
};

export type CreatePersonInput = {
  salutation: Scalars["String"];
  firstName?: Maybe<Scalars["String"]>;
  lastName: Scalars["String"];
  address: Scalars["String"];
};

export enum DefinedOnType {
  Hauptforderung = "HAUPTFORDERUNG",
  Nebenforderung = "NEBENFORDERUNG",
  ZinsenHauptforderung = "ZINSEN_HAUPTFORDERUNG",
  ZinsenNebenforderung = "ZINSEN_NEBENFORDERUNG",
}

export type Foko = {
  __typename?: "Foko";
  uuid: Scalars["String"];
  akte: Scalars["ID"];
  date: Scalars["Date"];
  parameters?: Maybe<Parameter>;
};

export enum GeneralType {
  Forderung = "FORDERUNG",
  Zinsen = "ZINSEN",
  Buchung = "BUCHUNG",
  Allgemein = "ALLGEMEIN",
}

export type Hauptforderung = {
  __typename?: "Hauptforderung";
  description: Scalars["String"];
  date: Scalars["Date"];
  amount: Scalars["Float"];
  zinsen?: Maybe<Zinsen>;
};

export type HauptforderungInput = {
  description: Scalars["String"];
  date: Scalars["Date"];
  amount: Scalars["Float"];
  zinsen?: Maybe<ZinsenInput>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Erstellt eine Akte */
  createAkte?: Maybe<Akte>;
  /** Aktualisiert eine Akte */
  updateAkte?: Maybe<Akte>;
  /** Löscht eine Akte */
  removeAkte?: Maybe<Akte>;
  /** Fügt einen Gläubiger hinzu oder entfernt diesen */
  updateAkteGlaeubiger?: Maybe<Akte>;
  /** Fügt einen Schuldner hinzu oder entfernt diesen */
  updateAkteSchuldner?: Maybe<Akte>;
  createFoko?: Maybe<Foko>;
  updateFoko?: Maybe<Foko>;
  removeFoko?: Maybe<Foko>;
  createPerson?: Maybe<Person>;
  updatePerson?: Maybe<Person>;
  removePerson?: Maybe<Person>;
};

export type MutationCreateAkteArgs = {
  data: CreateAkteInput;
};

export type MutationUpdateAkteArgs = {
  id: Scalars["ID"];
  data: UpdateAkteInput;
};

export type MutationRemoveAkteArgs = {
  id: Scalars["ID"];
};

export type MutationUpdateAkteGlaeubigerArgs = {
  id: Scalars["ID"];
  add?: Maybe<Array<Scalars["ID"]>>;
  remove?: Maybe<Array<Scalars["ID"]>>;
};

export type MutationUpdateAkteSchuldnerArgs = {
  id: Scalars["ID"];
  add?: Maybe<Array<Scalars["ID"]>>;
  remove?: Maybe<Array<Scalars["ID"]>>;
};

export type MutationCreateFokoArgs = {
  data: CreateFoko;
  akteID: Scalars["ID"];
};

export type MutationUpdateFokoArgs = {
  uuid: Scalars["ID"];
  data: UpdateFoko;
};

export type MutationRemoveFokoArgs = {
  uuid: Scalars["ID"];
};

export type MutationCreatePersonArgs = {
  data: CreatePersonInput;
};

export type MutationUpdatePersonArgs = {
  id: Scalars["ID"];
  data: UpdatePersonInput;
};

export type MutationRemovePersonArgs = {
  id: Scalars["ID"];
};

export type Nebenforderung = {
  __typename?: "Nebenforderung";
  description: Scalars["String"];
  date: Scalars["Date"];
  amount: Scalars["Float"];
  zinsen?: Maybe<Zinsen>;
};

export type NebenforderungInput = {
  description: Scalars["String"];
  date: Scalars["Date"];
  amount: Scalars["Float"];
  zinsen?: Maybe<ZinsenInput>;
};

export type Parameter = {
  __typename?: "Parameter";
  buchungen?: Maybe<Array<Maybe<Buchung>>>;
  hauptforderungen?: Maybe<Array<Maybe<Hauptforderung>>>;
  nebenforderungen?: Maybe<Array<Maybe<Nebenforderung>>>;
  zinsforderungen?: Maybe<Array<Maybe<Zinsforderung>>>;
  bemerkungen?: Maybe<Array<Maybe<Comment>>>;
};

export type ParameterInput = {
  buchungen?: Maybe<Array<Maybe<BuchungInput>>>;
  hauptforderungen?: Maybe<Array<Maybe<HauptforderungInput>>>;
  nebenforderungen?: Maybe<Array<Maybe<NebenforderungInput>>>;
  zinsforderungen?: Maybe<Array<Maybe<ZinsforderungInput>>>;
  bemerkungen?: Maybe<Array<Maybe<CommentInput>>>;
};

export type Person = {
  __typename?: "Person";
  id: Scalars["ID"];
  salutation: Scalars["String"];
  firstName?: Maybe<Scalars["String"]>;
  lastName: Scalars["String"];
  address: Scalars["String"];
  lastEdited?: Maybe<Scalars["Date"]>;
};

export type Query = {
  __typename?: "Query";
  /** Ruft alle Akten des aktuellen Benutzers ab (oder nur archivierte / aktive Akten, wenn archiviert festgelegt ist). */
  akten: Array<Akte>;
  /** Holen Sie sich die Akte mit der angegebenen ID, wenn der aktuelle Benutzer sie lesen darf. */
  akte?: Maybe<Akte>;
  /** Erstellt eine Aufstellung einer Akte */
  aufstellung?: Maybe<Aufstellung>;
  fokos: Array<Foko>;
  foko: Foko;
  /** Ruft alle Personen eines Users */
  personen: Array<Person>;
  person?: Maybe<Person>;
  users: Array<Maybe<User>>;
  user?: Maybe<User>;
  currentUser: User;
};

export type QueryAktenArgs = {
  archived?: Maybe<Scalars["Boolean"]>;
};

export type QueryAkteArgs = {
  id: Scalars["ID"];
};

export type QueryAufstellungArgs = {
  parameter: ParameterInput;
};

export type QueryFokosArgs = {
  akteID: Scalars["ID"];
};

export type QueryFokoArgs = {
  uuid: Scalars["String"];
};

export type QueryPersonArgs = {
  id: Scalars["ID"];
};

export type QueryUserArgs = {
  id: Scalars["ID"];
};

export enum SubType {
  Hauptforderung = "HAUPTFORDERUNG",
  Nebenforderung = "NEBENFORDERUNG",
  Zinsforderung = "ZINSFORDERUNG",
  Buchung_367Bgb = "BUCHUNG_367BGB",
  Buchung_491Bgb = "BUCHUNG_491BGB",
  BuchungHaupt = "BUCHUNG_HAUPT",
  BuchungKosten = "BUCHUNG_KOSTEN",
  BuchungZinsen = "BUCHUNG_ZINSEN",
  Zinsen = "ZINSEN",
  Info = "INFO",
  Bemerkung = "BEMERKUNG",
}

export type Tageszins = {
  __typename?: "Tageszins";
  date: Scalars["Date"];
  zins: Scalars["Float"];
};

export type UpdateAkteInput = {
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["Date"]>;
  archived?: Maybe<Scalars["Boolean"]>;
};

export type UpdateFoko = {
  parameters?: Maybe<ParameterInput>;
};

export type UpdatePersonInput = {
  salutation?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
};

export type User = {
  __typename?: "User";
  id: Scalars["ID"];
  name: Scalars["String"];
  email: Scalars["String"];
  configuredPermissions: Array<Scalars["String"]>;
};

export enum Verrechnung {
  Bgb367 = "BGB367",
  Bgb491 = "BGB491",
  Hpf = "HPF",
  Kosten = "KOSTEN",
  Zinsen = "ZINSEN",
}

export enum Verzinsung {
  Fest = "FEST",
  EzbStaffel = "EZB_STAFFEL",
}

export type Zinsen = {
  __typename?: "Zinsen";
  type: Verzinsung;
  startDate: Scalars["Date"];
  endDate?: Maybe<Scalars["Date"]>;
  zinssatz: Scalars["Float"];
  zinstage: Zinstage;
};

export type ZinsenInput = {
  type: Verzinsung;
  startDate: Scalars["Date"];
  endDate?: Maybe<Scalars["Date"]>;
  zinssatz: Scalars["Float"];
  zinstage: Zinstage;
};

export type Zinsforderung = {
  __typename?: "Zinsforderung";
  description: Scalars["String"];
  date: Scalars["Date"];
  amount: Scalars["Float"];
  zinsen: Zinsen;
};

export type ZinsforderungInput = {
  description: Scalars["String"];
  date: Scalars["Date"];
  amount: Scalars["Float"];
  zinsen: ZinsenInput;
};

export enum Zinstage {
  Kalender = "KALENDER",
  Bank = "BANK",
}

export type GetFokosByAkteQueryVariables = Exact<{
  akteId: Scalars["ID"];
}>;

export type GetFokosByAkteQuery = { __typename?: "Query" } & {
  fokos: Array<{ __typename?: "Foko" } & Pick<Foko, "uuid" | "date">>;
};

export type DeleteFokoMutationVariables = Exact<{
  fokoId: Scalars["ID"];
}>;

export type DeleteFokoMutation = { __typename?: "Mutation" } & {
  removeFoko?: Maybe<{ __typename?: "Foko" } & Pick<Foko, "akte">>;
};

export type CreateAkteOnPageMutationVariables = Exact<{
  data: CreateAkteInput;
}>;

export type CreateAkteOnPageMutation = { __typename?: "Mutation" } & {
  createAkte?: Maybe<{ __typename?: "Akte" } & Pick<Akte, "id">>;
};

export type CreateFokoByAkteMutationVariables = Exact<{
  akte: Scalars["ID"];
  data: CreateFoko;
}>;

export type CreateFokoByAkteMutation = { __typename?: "Mutation" } & {
  createFoko?: Maybe<
    { __typename?: "Foko" } & Pick<Foko, "uuid" | "akte" | "date">
  >;
};

export type UpdateAkteArchiveMutationVariables = Exact<{
  id: Scalars["ID"];
  data: UpdateAkteInput;
}>;

export type UpdateAkteArchiveMutation = { __typename?: "Mutation" } & {
  updateAkte?: Maybe<{ __typename?: "Akte" } & Pick<Akte, "id" | "archived">>;
};

export type CreateFokoMutationVariables = Exact<{
  akte: Scalars["ID"];
  data: CreateFoko;
}>;

export type CreateFokoMutation = { __typename?: "Mutation" } & {
  createFoko?: Maybe<
    { __typename?: "Foko" } & Pick<Foko, "uuid" | "akte" | "date">
  >;
};

export type GetAktenQueryVariables = Exact<{
  archived?: Maybe<Scalars["Boolean"]>;
}>;

export type GetAktenQuery = { __typename?: "Query" } & {
  akten: Array<
    { __typename?: "Akte" } & Pick<
      Akte,
      "id" | "title" | "description" | "date" | "lastEdited" | "archived"
    > & {
        glaeubiger: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "lastName" | "address"
          >
        >;
        schuldner: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "lastName" | "address"
          >
        >;
      }
  >;
};

export type CreateAkteMutationVariables = Exact<{
  data: CreateAkteInput;
}>;

export type CreateAkteMutation = { __typename?: "Mutation" } & {
  createAkte?: Maybe<{ __typename?: "Akte" } & Pick<Akte, "id">>;
};

export type GetAkteQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetAkteQuery = { __typename?: "Query" } & {
  akte?: Maybe<
    { __typename?: "Akte" } & Pick<
      Akte,
      "id" | "title" | "description" | "date" | "lastEdited" | "archived"
    > & {
        glaeubiger: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "firstName" | "lastName" | "address"
          >
        >;
        schuldner: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "firstName" | "lastName" | "address"
          >
        >;
      }
  >;
};

export type GetNavigationDataQueryVariables = Exact<{
  akteId: Scalars["ID"];
  fokoId: Scalars["String"];
}>;

export type GetNavigationDataQuery = { __typename?: "Query" } & {
  akte?: Maybe<{ __typename?: "Akte" } & Pick<Akte, "title">>;
  foko: { __typename?: "Foko" } & Pick<Foko, "date">;
};

export type GetAufstellungQueryVariables = Exact<{
  parameter: ParameterInput;
}>;

export type GetAufstellungQuery = { __typename?: "Query" } & {
  aufstellung?: Maybe<
    { __typename?: "Aufstellung" } & {
      entries: Array<
        { __typename?: "AufstellungListenEintrag" } & Pick<
          AufstellungListenEintrag,
          | "date"
          | "description"
          | "saldo"
          | "umsatz"
          | "generalType"
          | "subType"
          | "definedOn"
        >
      >;
      summary: { __typename?: "AufstellungZusammenfassung" } & Pick<
        AufstellungZusammenfassung,
        | "date"
        | "gesamt"
        | "hauptforderungen"
        | "kostenZinsen"
        | "summeZahlungen"
        | "unverzinslicheKosten"
        | "verzinslicheKosten"
        | "zinsenHauptforderungen"
      > & {
          tagesZins: { __typename?: "Tageszins" } & Pick<
            Tageszins,
            "date" | "zins"
          >;
        };
    }
  >;
};

export type GetFokoQueryVariables = Exact<{
  uuid: Scalars["String"];
}>;

export type GetFokoQuery = { __typename?: "Query" } & {
  foko: { __typename?: "Foko" } & Pick<Foko, "uuid" | "date"> & {
      parameters?: Maybe<
        { __typename?: "Parameter" } & {
          bemerkungen?: Maybe<
            Array<
              Maybe<
                { __typename?: "Comment" } & Pick<
                  Comment,
                  "date" | "description"
                >
              >
            >
          >;
          buchungen?: Maybe<
            Array<
              Maybe<
                { __typename?: "Buchung" } & Pick<
                  Buchung,
                  "description" | "date" | "amount" | "verrechnung"
                >
              >
            >
          >;
          hauptforderungen?: Maybe<
            Array<
              Maybe<
                { __typename?: "Hauptforderung" } & Pick<
                  Hauptforderung,
                  "date" | "description" | "amount"
                > & {
                    zinsen?: Maybe<
                      { __typename?: "Zinsen" } & Pick<
                        Zinsen,
                        | "startDate"
                        | "endDate"
                        | "type"
                        | "zinssatz"
                        | "zinstage"
                      >
                    >;
                  }
              >
            >
          >;
          nebenforderungen?: Maybe<
            Array<
              Maybe<
                { __typename?: "Nebenforderung" } & Pick<
                  Nebenforderung,
                  "date" | "description" | "amount"
                > & {
                    zinsen?: Maybe<
                      { __typename?: "Zinsen" } & Pick<
                        Zinsen,
                        | "startDate"
                        | "endDate"
                        | "type"
                        | "zinssatz"
                        | "zinstage"
                      >
                    >;
                  }
              >
            >
          >;
          zinsforderungen?: Maybe<
            Array<
              Maybe<
                { __typename?: "Zinsforderung" } & Pick<
                  Zinsforderung,
                  "date" | "description" | "amount"
                > & {
                    zinsen: { __typename?: "Zinsen" } & Pick<
                      Zinsen,
                      "startDate" | "endDate" | "type" | "zinssatz" | "zinstage"
                    >;
                  }
              >
            >
          >;
        }
      >;
    };
};

export type UpdateFokoMutationVariables = Exact<{
  uuid: Scalars["ID"];
  data: UpdateFoko;
}>;

export type UpdateFokoMutation = { __typename?: "Mutation" } & {
  updateFoko?: Maybe<{ __typename?: "Foko" } & Pick<Foko, "uuid">>;
};

export type GetAkteGlaebugierQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetAkteGlaebugierQuery = { __typename?: "Query" } & {
  akte?: Maybe<
    { __typename?: "Akte" } & Pick<Akte, "id"> & {
        glaeubiger: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "firstName" | "lastName"
          >
        >;
      }
  >;
};

export type UpdateAkteGlaeubigerMutationVariables = Exact<{
  id: Scalars["ID"];
  add?: Maybe<Array<Scalars["ID"]> | Scalars["ID"]>;
  remove?: Maybe<Array<Scalars["ID"]> | Scalars["ID"]>;
}>;

export type UpdateAkteGlaeubigerMutation = { __typename?: "Mutation" } & {
  updateAkteGlaeubiger?: Maybe<
    { __typename?: "Akte" } & Pick<Akte, "id"> & {
        glaeubiger: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "firstName" | "lastName"
          >
        >;
      }
  >;
};

export type CreatePersonMutationVariables = Exact<{
  data: CreatePersonInput;
}>;

export type CreatePersonMutation = { __typename?: "Mutation" } & {
  createPerson?: Maybe<{ __typename?: "Person" } & Pick<Person, "id">>;
};

export type RemovePersonMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RemovePersonMutation = { __typename?: "Mutation" } & {
  removePerson?: Maybe<{ __typename?: "Person" } & Pick<Person, "id">>;
};

export type UpdatePersonMutationVariables = Exact<{
  id: Scalars["ID"];
  data: UpdatePersonInput;
}>;

export type UpdatePersonMutation = { __typename?: "Mutation" } & {
  updatePerson?: Maybe<{ __typename?: "Person" } & Pick<Person, "id">>;
};

export type GetPersonenQueryVariables = Exact<{ [key: string]: never }>;

export type GetPersonenQuery = { __typename?: "Query" } & {
  personen: Array<
    { __typename?: "Person" } & Pick<
      Person,
      "id" | "salutation" | "firstName" | "lastName" | "lastEdited"
    >
  >;
};

export type GetAkteSchuldnerQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetAkteSchuldnerQuery = { __typename?: "Query" } & {
  akte?: Maybe<
    { __typename?: "Akte" } & Pick<Akte, "id"> & {
        schuldner: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "firstName" | "lastName"
          >
        >;
      }
  >;
};

export type UpdateAkteSchuldnerMutationVariables = Exact<{
  id: Scalars["ID"];
  add?: Maybe<Array<Scalars["ID"]> | Scalars["ID"]>;
  remove?: Maybe<Array<Scalars["ID"]> | Scalars["ID"]>;
}>;

export type UpdateAkteSchuldnerMutation = { __typename?: "Mutation" } & {
  updateAkteSchuldner?: Maybe<
    { __typename?: "Akte" } & Pick<Akte, "id"> & {
        schuldner: Array<
          { __typename?: "Person" } & Pick<
            Person,
            "id" | "salutation" | "firstName" | "lastName"
          >
        >;
      }
  >;
};

export const GetFokosByAkteDocument: DocumentNode<
  GetFokosByAkteQuery,
  GetFokosByAkteQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFokosByAkte" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "akteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fokos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "akteID" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "akteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const DeleteFokoDocument: DocumentNode<
  DeleteFokoMutation,
  DeleteFokoMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteFoko" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fokoId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeFoko" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fokoId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "akte" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const CreateAkteOnPageDocument: DocumentNode<
  CreateAkteOnPageMutation,
  CreateAkteOnPageMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateAkteOnPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateAkteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAkte" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const CreateFokoByAkteDocument: DocumentNode<
  CreateFokoByAkteMutation,
  CreateFokoByAkteMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateFokoByAkte" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "akte" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateFoko" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFoko" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "akteID" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "akte" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "akte" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const UpdateAkteArchiveDocument: DocumentNode<
  UpdateAkteArchiveMutation,
  UpdateAkteArchiveMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAkteArchive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateAkteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAkte" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const CreateFokoDocument: DocumentNode<
  CreateFokoMutation,
  CreateFokoMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateFoko" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "akte" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateFoko" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFoko" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "akteID" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "akte" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "akte" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetAktenDocument: DocumentNode<
  GetAktenQuery,
  GetAktenQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAkten" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "archived" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "akten" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "archived" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "archived" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "lastEdited" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "glaeubiger" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schuldner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const CreateAkteDocument: DocumentNode<
  CreateAkteMutation,
  CreateAkteMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateAkte" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateAkteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAkte" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetAkteDocument: DocumentNode<
  GetAkteQuery,
  GetAkteQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAkte" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "akte" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "lastEdited" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "glaeubiger" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schuldner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetNavigationDataDocument: DocumentNode<
  GetNavigationDataQuery,
  GetNavigationDataQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getNavigationData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "akteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fokoId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "akte" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "akteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foko" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fokoId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetAufstellungDocument: DocumentNode<
  GetAufstellungQuery,
  GetAufstellungQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAufstellung" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "parameter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ParameterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aufstellung" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "parameter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "parameter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "saldo" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "umsatz" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generalType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "definedOn" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gesamt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hauptforderungen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "kostenZinsen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summeZahlungen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tagesZins" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zins" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unverzinslicheKosten" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verzinslicheKosten" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zinsenHauptforderungen" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetFokoDocument: DocumentNode<
  GetFokoQuery,
  GetFokoQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFoko" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "foko" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parameters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bemerkungen" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "buchungen" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "verrechnung" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hauptforderungen" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zinsen" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "zinssatz" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "zinstage" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nebenforderungen" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zinsen" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "zinssatz" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "zinstage" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zinsforderungen" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zinsen" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "zinssatz" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "zinstage" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const UpdateFokoDocument: DocumentNode<
  UpdateFokoMutation,
  UpdateFokoMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateFoko" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateFoko" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateFoko" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetAkteGlaebugierDocument: DocumentNode<
  GetAkteGlaebugierQuery,
  GetAkteGlaebugierQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAkteGlaebugier" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "akte" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "glaeubiger" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const UpdateAkteGlaeubigerDocument: DocumentNode<
  UpdateAkteGlaeubigerMutation,
  UpdateAkteGlaeubigerMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateAkteGlaeubiger" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "add" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "remove" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAkteGlaeubiger" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "add" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "add" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "remove" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "remove" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "glaeubiger" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const CreatePersonDocument: DocumentNode<
  CreatePersonMutation,
  CreatePersonMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreatePerson" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreatePersonInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPerson" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const RemovePersonDocument: DocumentNode<
  RemovePersonMutation,
  RemovePersonMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemovePerson" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removePerson" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const UpdatePersonDocument: DocumentNode<
  UpdatePersonMutation,
  UpdatePersonMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdatePerson" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdatePersonInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePerson" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetPersonenDocument: DocumentNode<
  GetPersonenQuery,
  GetPersonenQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPersonen" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "personen" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "salutation" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "lastEdited" } },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const GetAkteSchuldnerDocument: DocumentNode<
  GetAkteSchuldnerQuery,
  GetAkteSchuldnerQueryVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAkteSchuldner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "akte" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schuldner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
export const UpdateAkteSchuldnerDocument: DocumentNode<
  UpdateAkteSchuldnerMutation,
  UpdateAkteSchuldnerMutationVariables
> = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateAkteSchuldner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "add" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "remove" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAkteSchuldner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "add" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "add" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "remove" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "remove" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schuldner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};
